import PropTypes from 'prop-types'

import cn from '@/utilities/cn'

import Label from './Label'
import Value from './Value'

import './index.scss'

import defaultProps from '@/components/Form/defaultProps'
import propTypes from '@/components/Form/propTypes'

const KeyValue = ({ children, className }: any) => {
  return <div className={cn(className, 'keyvalues')}>{children}</div>
}

KeyValue.Label = Label
KeyValue.Value = Value

KeyValue.displayName = 'KeyValue'

KeyValue.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: propTypes.className
}
KeyValue.defaultProps = {
  children: null,
  className: defaultProps.className
}
export default KeyValue
